import React from 'react';
import MenuCliente from '../Components/MenuCliente/menucliente';
import './home.css';

function Home(){
    return <div>
      <MenuCliente />
    </div>;
  }

export default Home;